export const transmitText =
    'Recuerda que para dar clic en esta opción debes tener completa la liquidación de la nómina de tus empleados y que la información se encuentre actualizada.';
export const confirmTransmisonText =
    'Recuerda confirmar la transmisión para enviar la nómina. Si editaste o agregaste información de tus empleados, asegúrate de liquidar nuevamente la nómina en el módulo de liquidación antes de continuar.';
